import { ChakraStyledOptions } from '@chakra-ui/react';

export const badgesTheme = {
    baseStyle: (options: ChakraStyledOptions) => ({
        bgColor: `${options.colorScheme}.50`,
        color: `${options.colorScheme}.700`,
        fontSize: 'smaller',
        borderWidth: 1,
        borderColor: `${options.colorScheme}.400`,
        fontWeight: 'bold',
        textTransform: 'none',
        borderRadius: 'md',
        px: 2,
    }),
    sizes: {
        sm: {
            fontSize: 'xs',
            px: 1,
        },
        md: {
            fontSize: 'smaller',
            px: 1,
        },
        lg: {
            fontSize: 'sm',
            px: 1,
        },
    },
    variants: {
        outline: (options: ChakraStyledOptions) => ({
            color: `${options.colorScheme}.500`,
            borderColor: `${options.colorScheme}.500`,
            bgColor: 'white',
            boxShadow: 'none',
        }),
        solid: (options: ChakraStyledOptions) => ({
            bgColor: `${options.colorScheme}.400`,
            color: 'white',
        }),
        subtle: (options: ChakraStyledOptions) => ({
            borderColor: `${options.colorScheme}.50`,
        }),
        ghost: {
            borderColor: 'transparent',
            bgColor: 'transparent',
        },
        default: (options: ChakraStyledOptions) => ({
            bgColor: `${options.colorScheme}.50`,
            color: `${options.colorScheme}.700`,
            borderColor: `${options.colorScheme}.400`,
        }),
    },
    defaultProps: {
        size: 'md',
        variant: 'subtle',
    },
};
